export default class MainNavigation {
	static init() {
		let $navigation = jQuery( '#main-navigation' );
		if ( $navigation.length ) {

			// Add a positioning indicator for main-navigation. This indicator should receive fixed positioning under the same conditions a the navigation, except for the scroll position.
			$navigation.after( '<div id="main-navigation-indicator"></div>' );

			// Wrap #main-navigation with placeholder in case #main-navigation gets fixed positioning. The placeholder should take up the same amount of vertical space as the navigation bar
			$navigation.wrap( '<div id="main-navigation-placeholder" class="main-navigation-placeholder scroll-observe"></div>' );

			jQuery( window ).on( 'load theme:scroll theme:resize theme:menu-was-toggled', MainNavigation.placeholderRecalculate );
		}
	}

	static placeholderRecalculate() {
		// Using outerHeight here in case #main-navigation has a border
		let navigationHeight = Math.round( jQuery( '#main-navigation' ).outerHeight() );
		let $placeholder = jQuery( '#main-navigation-placeholder' );
		if ( navigationHeight !== Math.round( $placeholder.outerHeight() ) ) {
			if ( $placeholder.data( "targetHeight" ) !== navigationHeight ) {
				// The height changed, this could be caused by an ongoing animation, so we schedule a recalculation on the next frame.
				requestAnimationFrame( MainNavigation.placeholderRecalculate );
				$placeholder.data( "targetHeight", navigationHeight );
			}
			$placeholder.outerHeight( navigationHeight );
		}
	}
}
